module.exports = __webpack_public_path__ + "img/album18_47.b6dc29a3.jpg";